const toBoolean = (value) => value === 'true';

export const env = {
	api_url: process.env.REACT_APP_API_URL || '',
	tinymce_api_key: process.env.REACT_APP_TINYMCE_API_KEY || '',
	use_type_product: toBoolean(process.env.REACT_APP_USE_TYPE_PRODUCT || 'false'),
	use_type_consult: toBoolean(process.env.REACT_APP_USE_TYPE_CONSULT || 'false'),
	use_introduce: toBoolean(process.env.REACT_APP_USE_INTRODUCE || 'true'),
};
